import { IconButton } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import OrgTextField from "@material-ui/core/TextField";
import AddIcon from "@material-ui/icons/Add";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { incidentColors, OneDataSource } from "lego-gui-lib";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: "0 10",
      width: "100%",
      height: "70px"
    },
    addBar: {
      margin: "0 auto"
    },
    iconButton: {
      padding: 10
    },
    errorMessage: {
      margin: "5px 14px 5px 14px",
      fontSize: 12,
      color: incidentColors.critical
    }
  })
);

export interface SimpleCreateFieldProps {
  minNumberOfLetters: number;
  placeholder?: string;
  dataSource: OneDataSource<any, any>;
  fieldName: string;
  initialValues?: {};
}

export const SimpleCreateField = observer((props: SimpleCreateFieldProps) => {
  const [text, setText] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const classes = useStyles();
  const {
    fieldName,
    minNumberOfLetters,
    placeholder,
    dataSource,
    initialValues
  } = props;

  const handleKeyExecute = (event: any) => {
    if (event.key === "Enter" && text.length > props.minNumberOfLetters) {
      handleAdd();
    }
  };

  const handleChange = (event: any) => {
    setText(event.target.value);
    checkLength(event.target.value);
    dataSource.change({ [fieldName]: event.target.value, ...initialValues });
  };

  const handleAdd = async () => {
    try {
      await dataSource.save().then(() => {
        setText("");
        setErrorMessage("");
      });
    } catch (e) {
      if (e.response && e.response.data) {
        if (e.response.data.message) {
          setErrorMessage(e.response.data.message);
        } else {
          setErrorMessage("failed to submit form");
        }
      }
    }
  };

  const checkLength = (typed: string) => {
    if (typed.length <= minNumberOfLetters) {
      setErrorMessage(
        `Input should be longer than ${minNumberOfLetters} characters`
      );
    } else {
      setErrorMessage("");
    }
  };

  return (
    <div className={classes.root}>
      <OrgTextField
        placeholder={placeholder}
        onChange={handleChange}
        onKeyPress={handleKeyExecute}
        value={text}
        variant="outlined"
        fullWidth={true}
        error={errorMessage !== ""}
        helperText={errorMessage}
        className={classes.addBar}
        margin="dense"
        InputProps={{
          endAdornment: (
            <IconButton
              className={classes.iconButton}
              aria-label="search"
              onClick={handleAdd}
              disabled={text.length < minNumberOfLetters}
            >
              <AddIcon />
            </IconButton>
          )
        }}
      />
    </div>
  );
});
